import { ThemeOptions } from '@mui/material/styles';

export const proctorPalette = {
    primary: {
        main: '#4462A2',
        light: '#4C7BD9',
        dark: '#2F477B',
        contrastText: '#F2F2F2',
    },
    secondary: {
        main: '#f50057',
        light: '#f73378',
        dark: '#ab003c',
        contrastText: '#F2F2F2',
    },
    sidebarHeader: {
        main: '#2F477B',
        contrastText: '#F2F2F2',
    },
    appHeader: {
        main: '#AE985E',
        contrastText: '#000',
    },
    addButton: {
        main: '#3f51b5',
        light: '#fafbff',
    },
    menuListHover: {
        main: '#f0f0f0',
        light: '#f7f7f7',
    },
    btnDefault: {
        main: '#000000de',
        light: '#F5F5F5',
    },
} as ThemeOptions['palette'];
